import * as angular from 'angular';

const newOnPremConnection = {onPremisesConnectionEnabled: false, adAgentUrl: '', adAgentPublicCertificate: ''};

export class Controller {
    /** @ngInject */
    constructor($state, Alert, DirectoriesResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
        this.onPremConnection = {...(this.initialValue || newOnPremConnection)};
    }

    notModified() {
        return angular.equals(this.onPremConnection, this.initialValue || newOnPremConnection);
    }

    updateOnPremisesConnectionSettings() {
        this.isSaving = true;
        this.DirectoriesResource.updateOnPremisesConnectionSettings(
            this.companyId,
            this.directoryId,
            this.onPremConnection,
        )
            .then(() => this.onSave())
            .then(() => this.Alert('success', 'company.directory-integration.on-premises-form.saved'))
            .finally(() => (this.isSaving = false));
    }

    saveDisabled() {
        return this.form.$invalid || this.isSaving || this.notModified();
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection/on-premises-form/on-premises-form.controller.js